import {type PayloadAction, createSlice} from '@reduxjs/toolkit';
import type {DataLoadStatus} from 'api/types';
import type {
  Thesaurus,
  ThesaurusId,
  ThesaurusesState,
} from 'services/thesaurus/types';
import type {RootState} from 'store/types';

const initialState: ThesaurusesState = {};

const thesaurusSlice = createSlice({
  name: 'thesaurus',
  initialState,
  reducers: {
    loadThesaurus: (
      state,
      action: PayloadAction<{
        id: ThesaurusId;
        data: DataLoadStatus<Thesaurus>;
      }>,
    ) => {
      state[action.payload.id] = action.payload.data;
    },
  },
});

export const {loadThesaurus} = thesaurusSlice.actions;
export const selectThesaurus = (state: RootState) => state.thesaurus;

export default thesaurusSlice;
